module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("C")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cabala:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kabalah.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cabales; Caballi:")]), _vm._v(" In occultism, “the astral bodies of those who died by violence (external or self-inflicted) prior to the end of their natural term of life. These earth-bound, suffering souls are said to wander within the sphere of the attraction of the earth until the end of their natural term of life.” (L. W. de Laurence)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cabinet:")]), _vm._v(" The designation of the space, enclosed by curtains, in which mediums claim to condense the psychic energy required for manifestations in the seance room.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cabiri:")]), _vm._v(" A group of minor deities often mentioned in ancient writings as powerful masters of magic. They were probably of Semitic origin, and their worship as gods of mysteries was widespread in Greece, especially in Samothrace, Bœotia and Thessaly.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cocodemon:")]), _vm._v(" A malignant demon, regarded as a fallen angel (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Caduceus:")]), _vm._v(" The wand of Hermes, or Mercury, the messenger of the gods. A cosmic, magic, or astronomical symbol; its significance changing with its application. Originally a triple-headed serpent, it is now a rod with two serpents twined around it, and two wings at the top. The entwined white and black serpents represent the struggle between good and evil—disease and cure. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aaron’s Rod.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Caitanya:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("consciousness")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("intelligence;")]), _vm._v(" the universal intelligence or spirit; a quality near the in-it-self aspect of the Absolute Spirit, and hence sometimes a synonym for it.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Calx:")]), _vm._v(" In alchemical terminology, a metallic oxide.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Camaxtli:")]), _vm._v(" An ancient Mexican war god, often identified with Mixcoatl.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cambion:")]), _vm._v(" The offspring of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("incubi")]), _vm._v(" and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("succubi")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Camp meeting:")]), _vm._v(" The earlier name of the assemblies of spiritualists.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cancer")]), _vm._v(" (The Crab): The fourth sign of the Zodiac. Its symbol ("), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9780806537009_i0005.jpg",
      "src": "Book1/e9780806537009_i0005.jpg"
    }
  })]), _vm._v("), presumably the folded claws of a crab, probably is intended to symbolize the joining together of a male and female spermatozoa—as indicative of the most maternal of all the signs. The Sun is in Cancer annually from June 21 to July 22. Astrologically it is the first thirty-degree arc following the Summer Solstice, marked by the Sun’s passing of the Tropic of Cancer, and occupying a position along the Ecliptic from 90° to 120°. It is the “leading” quality of the element Water: negative, cold, moist, phlegmatic, nocturnal, commanding, movable, fruitful, weak, unfortunate, crooked, mute. Ruler, Moon. Exaltation: Jupiter. Detriment: Saturn. Fall: Mars.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Canopic jar:")]), _vm._v(" The jar into which the embalmers of ancient Egypt put the intestines and other internal organs of the corpse being embalmed.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Caodaism:")]), _vm._v(" An esoteric religion and mystery cult founded in Indo-China in the 1920’s, claiming to have received its teaching from the Supreme Being ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cao Dai")]), _vm._v(") through spiritualistic implements. It honors Christ, Buddha, Confucius and Lao-Tzu as saviors sent by the same deity. It teaches the existence of the soul, reincarnation and the law of Karma.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Capnomancy:")]), _vm._v(" Divination based on the smoke of an altar or a hearth as divinatory sign.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Capricorn")]), _vm._v(" (The Goat): The tenth sign of the Zodiac. In Hindu astrology, Makarar—and considered by the ancients to be the most important of all the signs. Its symbol ("), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9780806537009_i0006.jpg",
      "src": "Book1/e9780806537009_i0006.jpg"
    }
  })]), _vm._v(") represents the figure by which the sign is often pictured—that of the forepart of a goat, with the tail of a fish—vaguely suggesting the mermaid. Sometimes also by the sea-goat, or dolphin. It is said to have a reference to the legend of the goat and the Sun gods. The Sun is in Capricorn annually from December 22 to January 20. Astrologically it is the first thirty degrees following the Winter Solstice, marked by the passing of the Sun over the Tropic of Capricorn and occupying a position along the Ecliptic from 270° to 300°. It is the “leading” quality of the element Earth: negative, nocturnal, cold, dry, obeying. Ruler: Saturn. Exaltation: Mars. Detriment: Moon. Fall: Jupiter. Symbolic interpretation: A goat with a fish’s tail, signifying extremes of height and depth; changes wrought by time; union of the Christian and Jewish religious dispensations.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cardinal signs:")]), _vm._v(" In astrology, the signs Aries, Cancer, Libra and Capricorn—whose cusps coincide with the cardinal points of the compass: Aries, East; Cancer, North; Libra, West; and Capricorn, South.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cardinal virtues:")]), _vm._v(" The cardinal virtues for a given culture are those which it regards as primary, the others being regarded either as derived from them or as relatively unimportant. Thus the Greeks had four: wisdom, courage, temperance, and justice; to which the Christians added three: faith, hope, and love or charity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cartomancy:")]), _vm._v(" Divination by cards.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Casting off of sins:")]), _vm._v(" The Jewish ceremony, called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Tashlikh")]), _vm._v(" in Hebrew, in which crumbs of bread symbolizing one’s sins are thrown into a river, thus symbolizing the casting off of one’s sins.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Casting the horoscope:")]), _vm._v(" The term used by astrologers to imply the calculations necessary to be made, prior to the delineation of the nativity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Castle of the Inferior Man:")]), _vm._v(" In mysticism, the allegorical name of the seven stages of the soul’s ascent toward the Divinity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Catalepsy:")]), _vm._v(" A death-like state of physical coma, bodily rigidity, in which normal functions of the body, including sensations, are suspended and consciousness ceases; it may last from minutes to days. According to certain occultists, it is produced primarily in the astral body during the process of exteriorization.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cataplexy:")]), _vm._v(" Catalepsy (q.v.) in animals.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Catoptromancy:")]), _vm._v(" An ancient Greek method of divination by observing images reflected in a mirror suspended in a fountain.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Causal body:")]), _vm._v(" “This term denotes the vehicle of the spiritual ego in the higher mind of each individual. It is usually called the immortal soul, for it persists throughout the cycle [of reincarnations]. To it are attached the vehicles of the personality or personal ego, on the lower planes.” (G. A. Gaskell)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Causality:")]), _vm._v(" The relationship between cause and effect, events, processes, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cause:")]), _vm._v(" Something, the existence of which is a pre-condition of the existence of something else; in the words of Leukippus, “Nothings happens without a ground but everything through a cause and of necessity.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Celestial light:")]), _vm._v(" The light which shimmers around certain mystical visions and can be seen only by those who have led a clean life, when the vital spark has almost departed from the physical body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Celestial voyage:")]), _vm._v(" In shamanism, the ecstatic trance of the shaman.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Centaur:")]), _vm._v(" In Greek-Roman mythology, a creature who is half man and half horse.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cerberus:")]), _vm._v(" In Greek mythology, the three-headed dog guarding the entrance to Hades, the underworld.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ceremonial magic:")]), _vm._v(" Magic based on the invocation of powers above man’s level on the scale of being, and giving man command over elementals (q.v.) by the use of certain rites and rituals.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ceres:")]), _vm._v(" The Roman mother-goddess, identified with the Greek goddess Demeter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ceromancy:")]), _vm._v(" Divination by interpreting the shapes and positions assumed by melted wax dropped on the floor.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chain:")]), _vm._v(" In spiritualistic terminology, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("forming a chain")]), _vm._v(" at a seance means that those sitting around the table join hands, in order to strengthen the magnetic current of their bodies.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chakra:")]), _vm._v(" In Yogi philosophy, one of the stages of the development of spiritual force in man.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chakra:")]), _vm._v(" In theosophical terminology, a sense organ of the ethereal body, visible only to a clairvoyant. There are ten "), _c('em', {
    staticClass: "i"
  }, [_vm._v("chakras,")]), _vm._v(" which permit those trained in their use to gain knowledge of the astral world. (Three of the ten "), _c('em', {
    staticClass: "i"
  }, [_vm._v("chakras")]), _vm._v(" are used in black magic only.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chaldean Oracle:")]), _vm._v(" An Oracle venerated as highly by the Chaldeans as was the one at Delphi by the Greeks. It promised victory to anyone who developed masterly will, and taught that “Though Destiny may be written in the stars, it is the mission of the divine soul to raise the human soul above the circle of necessity.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ch’an school of Buddhism:")]), _vm._v(" The Chinese equivalent of the Japanese Zen Buddhism (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ch’ang:")]), _vm._v(" Chinese for “Invariables” or universal and eternal laws or principles running through the phenomenal change of the universe. (Lao Tzu.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Changeling:")]), _vm._v(" The little mannikin which, according to Celtic folklore, the “little people” leave in the cradle of a human infant they steal. The changeling, about the size of the infant, has a wizened face and does not grow normally.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ch’ang sheng:")]), _vm._v(" In the philosophy of Lao Tzu, everlasting existence, such as that of Heaven and Earth, because of their “not existing for themselves.” In Taoist religious terminology: 1) Long life, as a result of the nourishment of the soul and rich accumulation of virtue. 2) Immortality, to be achieved through internal alchemy and external alchemy ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("lien tan")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Changing Woman:")]), _vm._v(" The most beloved deity of the Navajo Indians; mother of Monster Slayer and Child of the Water who slew the monsters which threatened mankind.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chaomancy:")]), _vm._v(" Divination by observing and interpreting atmospheric appearances.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chaos:")]), _vm._v(" The formless, undifferentiated primal matter which existed before Creation, and out of which matter and the universe was formed.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Charm:")]), _vm._v(" Any magic word, formula, incantation, object, sign or amulet supposed to possess occult power.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chasid, Chasidism:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hasid, Hasidism.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chat:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("physical body.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chela:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("disciple.")]), _vm._v(" (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("accepted chela.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cherub:")]), _vm._v(" In Hebrew mysticism, a winged celestial being, part human and part animal, serving as the chariot of the Almighty and as guardian angel. (Plural: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cherubim.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ch’i:")]), _vm._v(" Chinese for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("force, spirit.")]), _vm._v(" Used in esoteric terminology also for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("breath,")]), _vm._v(" the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("vital fluid.")]), _vm._v(" Also as the name of the Spirits of Earth (the gods of the ground and the grain, mountains, rivers and valleys).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chih jen:")]), _vm._v(" Chinese for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("the perfect man;")]), _vm._v(" one who has reached a state of mystical union with the universe, or “one who has not separated from the true.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chin tan:")]), _vm._v(" The Chinese term for the alchemical transmutation of mercury into gold.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ching shen:")]), _vm._v(" Chinese for the spirit and soul of man, or “the vital force ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("ch’i")]), _vm._v(") and the keeper of life of man,” which is endowed by Heaven as against the physical form which is endowed by Earth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chirognomy:")]), _vm._v(" That branch of palmistry (q.v.) which purports to deduce a person’s intelligence from the form of his hands.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chiromancy:")]), _vm._v(" The art of divination from the shape of the hand and fingers and the lines and other markings which appear on them.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chirosophy:")]), _vm._v(" That branch of palmistry (q.v.) which studies the comparative value of hand forms.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chit:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("consciousness;")]), _vm._v(" intelligence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chiton:")]), _vm._v(" Burmese name for evil spirits.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chrestos:")]), _vm._v(" An ancient Greek term, used by Gnostics of the first centuries of Christianity for Christ.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Christ myth:")]), _vm._v(" A theory popular in Germany from about 1910. It represents Jesus as either an astral deity who came to earth, suffered, died and rose again, or as the projection of the repressed social, economic and political aspirations of the lower classes in the Roman Empire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Christian Science:")]), _vm._v(" A religion and philosophy, founded in 1875 by Mary Baker Eddy, based on the teaching that God, the Universal Mind, is the only existing reality, man is God’s spiritual idea and belongs by right to an order in which there is no sickness, sin, sorrow or death; all such things are errors of man’s mortal mind and have no reality for man save as he admits them; if man denies them, they cease to exist.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Christian Spiritualists:")]), _vm._v(" Spiritualists who stand by the Bible and emphasize the mastership of Jesus Christ.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Churinga:")]), _vm._v(" A fetish of the Australian aborigines: a long piece of wood in which the spirit of one’s ancestor is supposed to dwell.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cihuateteo:")]), _vm._v(" In Aztec demonology, evil female demons, the spirits of women who died in childbirth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Circle:")]), _vm._v(" In spiritualist terminology, a group including at least one medium, which holds meetings and seances for the purpose of communicating with the spirits of the dead and other discarnate entities.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Circumambulation:")]), _vm._v(" Ceremonial walking around an object or a person. This ritual has been and is used in many religions, mystery ceremonies, etc., and occult philosophy attributes a mystic power and significance to it. It is usually done keeping one’s right side toward the object or person encircled, to show respect, to secure protection or good fortune, etc.; walking in the reverse direction shows disrespect and is held to have evil effects.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Civa:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Shiva.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Clairaudience:")]), _vm._v(" In occult terminology, the psychic ability to hear sounds or voices regardless of distance.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Clairsentience:")]), _vm._v(" An occult term indicating psychic sensitivity; “that peculiar feeling that something is going to happen.” Almost everyone possesses instinctive and intuitive clairsentience to some degree, popularly often referred to as a “hunch.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Clairvoyance:")]), _vm._v(" In occultism, the ability to see things and events regardless of distance; the gift of spiritual sight (“sight with the inner eye”).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Clavicle of Solomon:")]), _vm._v(" An alternative designation of the book, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Key of Solomon the King")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cledonismantia; cledonism:")]), _vm._v(" The belief in and divination of the good or evil portent of certain spontaneously spoken words when meeting another person or other persons.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cleromancy:")]), _vm._v(" Divination by studying the shapes formed by pebbles thrown on a flat surface.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Clidomancy:")]), _vm._v(" Divination by using a Bible and a hanging key, interpreting the movements of the latter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cloud of the Law:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dasa-bhumi.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cloven foot:")]), _vm._v(" In the lore of Satanism and witchcraft and in demonology, the distinctive mark of the devil.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cluricane:")]), _vm._v(" In Irish folklore, an evil elf who usually appears in the shape of an old man; he is supposed to know where hidden treasure can be found.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Color awareness:")]), _vm._v(" According to occult teachings, color and color scheme exercise a tremendous influence on the human mind, and by learning the mastery of colors, man can become the master of his thought power and ruler of his destiny.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Color therapy:")]), _vm._v(" The practical application, for therapeutic purposes, of the teaching that color affects emotions, health, mental states and conduct in general. (See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("color awareness")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Comasonry:")]), _vm._v(" A variety of Freemasonry permitting the initiation of women, too.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Combust:")]), _vm._v(" In astrological terminology, a planet is said to be in the combust condition when in extreme closeness to the Sun, the limits variously placed at from 3° to 8°30’.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Commanding signs:")]), _vm._v(" The term applied in astrology to the signs Aries, Taurus, Gemini, Cancer, Leo, and Virgo, because they were deemed more powerful by virtue of their nearness to the zenith.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Communicograph:")]), _vm._v(" A mechanical instrument for communicating with the spirits of the dead. The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ashkir-Jobson Communicograph")]), _vm._v(" consists of a small table with a free-swinging pendulum under it, which can make contact with any of a number of small metal plates bearing the letters of the alphabet; when the contact is made, an electric circuit is closed and the proper letter appears, illuminated on the surface of the table. The “spirit messages” are spelled out letter by letter this way.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Community of sensation:")]), _vm._v(" In general, the sharing of sensations by persons in psychic or spiritual rapport with each other; also, in hypnotism and trance states.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Compathy:")]), _vm._v(" Literally, “with-each-other-feeling.” Men feel with each other the same sorrow, the same pain. Only psychical suffering can thus be felt, not physical pain. There is no symagony.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Concentration:")]), _vm._v(" The act and state of focusing one’s entire attention and perception upon a certain object or idea, to the complete exclusion of all others, and under total inactivity of all the physical senses except the one used in this act (e.g., sight, hearing, etc.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Conception:")]), _vm._v(" According to Ptolemy the sex as well as the incidents relating to a child, prior to its birth, may be deduced from the positions of the planets at the time of conception.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Confucianism:")]), _vm._v(" Worship of Confucius, a state cult of China. See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ju Chia")]), _vm._v(" and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ju Chiao.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Conjunction; conjoined to:")]), _vm._v(" Terms used in astrology to indicate the mutual relation of two planets occupying longitudinal positions separated by less than 7°. (Strictly speaking, the conjunction takes place when both occupy exactly the same degree position.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Conjuration:")]), _vm._v(" The method, act or process of summoning supernatural aid by calling on divine or evil forces, by incantation or rituals of sorcery or black magic.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Conjuring lodge:")]), _vm._v(" The tent or hut of the North American Indian tribes in which mediumistic practices were held. The primitive form of the seance "), _c('em', {
    staticClass: "i"
  }, [_vm._v("cabinet")]), _vm._v(" (q.v.) of modern spiritualists.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Conjuror:")]), _vm._v(" A sorcerer or black magician.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Consciousness:")]), _vm._v(" A designation applied to conscious mind as opposed to a supposedly unconscious or subconscious mind, and to the whole domain of the physical and non-mental. (See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Field of consciousness.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contagious magic:")]), _vm._v(" Magic based on the belief that things which once have been in contact continue to have an influence on each other after their separation; for instance, that a person can be harmed by the performing of rites of black magic over tufts of his hair, nail parings, discarded personal property, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Contemplation:")]), _vm._v(" Knowledge consisting in the partial or complete identification of the knower with the object of knowledge, with the consequent loss of his own personality.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Control:")]), _vm._v(" In spiritualism, this term is applied to the state of possession of the medium by an invisible entity which uses the body of the medium as an instrument for communicating with those present at the seance. The term "), _c('em', {
    staticClass: "i"
  }, [_vm._v("control")]), _vm._v(" is used also to designate this invisible “operator,” also referred to as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("guide")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Copper age:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dwapara Yuga")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Corpora superœlestia:")]), _vm._v(" This Latin term (meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("super-heavenly bodies")]), _vm._v(") is applied by spiritualists to forms regarded "), _c('em', {
    staticClass: "i"
  }, [_vm._v("as")]), _vm._v(" the refined, intelligent elements of astral forms, visible only through highest spiritual perception.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Corybantes:")]), _vm._v(" Priests of Cybele who conducted the celebrations of the Phrygian Cybele mysteries.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmecology:")]), _vm._v(" This title (meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("the ecology of the cosmic")]), _vm._v(") was suggested by Harlan T. Stetson, of the Massachusetts Institute of Technology, for a synthesis of the contemporary sciences of astronomy, electro-physics, geology and biology. He suggested that we trace the correlation between changes of a cosmic origin that affect our terrestrial environment, and periods of optimism and depression in the psychology of the human race.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic:")]), _vm._v(" Relating to or originating from the cosmos.—In Rosicrucian usage, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cosmic")]), _vm._v(" is used as a noun as well as an adjective. Used as a noun, it means “the Universe as a harmonious relation of all natural and spiritual laws. As used in a Rosicrucian sense, the Divine, Infinite Intelligence of the Supreme Being permeating everything, the creative forces of God” (Rosicrucian Manual). (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kosmos, kosmic")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic conditioning:")]), _vm._v(" The ancient belief that one’s destiny upon earth is ruled by the divine power that placed the stars in the heavens; that every created thing is a result of this influence; and that the Sun is the active principle of good, and the darkness of evil.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic consciousness:")]), _vm._v(" That faculty, as yet possessed only by some exceptionally gifted individuals, but regarded by occultists as the eventual goal of future human evolution, consisting of the conscious awareness of the cosmos, of the life and order of the universe.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic epochs:")]), _vm._v(" According to occult teachings, the constellation in which the sun is astronomically and astrologically, rules the destiny of the world and determines the nature of happenings in our world. The current epoch, which started in 1948, is called Aquarian, and was preceded by the Piscean Epoch (the primitive Christian era), which followed the Aries or Ram Epoch (the Mosaic era), which was preceded by the Taurus Epoch (Egyptian and Hebraic epoch), which followed the Gemini Epoch (the Adamic period).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic ideation:")]), _vm._v(" The theosophist term for “eternal thought impressed on substance or spirit-matter, in the eternity; thought which becomes "), _c('em', {
    staticClass: "i"
  }, [_vm._v("active")]), _vm._v(" in the beginning of every new life-cycle.” (H. P. Blavatsky)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic mind:")]), _vm._v(" In general, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Universal Mind")]), _vm._v(" (q.v.); specifically, the mind that is a part of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("cosmic consciousness")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic numbers:")]), _vm._v(" In numerology, the oudad (0), the monad (1), the dyad (2), the triad (3), the tetrad (4), the pentad (5), the hexad (6), the heptad (7), the octad (8), the ennead (9), and the decad (10).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic philosophy:")]), _vm._v(" A theory of cosmic evolution originated by John Fiske and advanced by him as an interpretation of Spencer. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("cosmism")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic picture gallery:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Akashic Records")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmic psychology:")]), _vm._v(" The science of diagnosis whereby the maladjustment of the individual to life can be treated by correctional thinking. It does not concern itself with prediction, fortune-telling, life readings, but deals with reactions developed in the individual by virtue of growth and development during his first day of life, through the law of adaptability to cosmic ray frequencies then present in the Earth’s magnetic field, and with experiences resulting from environmental stimulation of a preconditioned pattern of emotional reactions.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmical:")]), _vm._v(" In astrology, said of the rising or setting of a planet (or a star) when it is near the Sun—hence rises and sets along with it.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmism:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cosmic philosophy.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmogony:")]), _vm._v(" A pictorial treatment of the way in which the world or the universe came into being. In contrast to the most primitive civilizations, the great ethnic stocks of mankind have originated cosmogonies.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmology:")]), _vm._v(" A branch of philosophy which treats of the origin and structure of the universe.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cosmos:")]), _vm._v(" The universe, as distinguished from our earth. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kosmos")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Councillor gods:")]), _vm._v(" A term applied, by the Chaldeans, to the three bright stars in a constellation, which served to mark the position of the ruling planet of that sign, when in the sign.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Countercharm:")]), _vm._v(" A charm used to nullify the effect of another charm.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Couril:")]), _vm._v(" A web-footed dwarf fairy supposed to haunt Druidic ruins in Ireland and Brittany.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Couvade:")]), _vm._v(" The custom, of magic significance, observed by a great many primitive races all over the world, which requires the father of a newborn child to lie in bed for a certain number of days.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Coyote:")]), _vm._v(" A cunning and resourceful nature-spirit found in the myths of many American Indian tribes; most tribes regard him as a malignant spirit, but in the myths of some tribes he is a benefactor of mankind.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Crab:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cancer.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Crithomancy:")]), _vm._v(" An ancient method of divination by observing the pattern formed by grain or particles of flour, in connection with sacrificial rites.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Critical day:")]), _vm._v(" In occultism, astrology, etc., a day which is destined or able to bring bad luck.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cromaat:")]), _vm._v(" A mystic word, interpreted as Egyptian for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("as in truth,")]), _vm._v(" frequently used as a salutation in the Rosicrucian rituals.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cross-correspondence:")]), _vm._v(" In parapsychological investigations, the term for concordances appearing in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("automatic writings")]), _vm._v(" (q.v.), etc., executed by two or more mediums, which are demonstrably not deliberately inserted.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cross-reference:")]), _vm._v(" In spiritualist terminology, the simultaneous delivery of spirit messages through two or more different mediums, with a request to forward them to the right person.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Crow’s head:")]), _vm._v(" In medieval alchemical terminology, the blackness of the mixture intended to produce the Philosopher’s Stone (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cru.x ansata:")]), _vm._v(" A cross consisting of a T shape with an oval loop at the top, used by the ancient Egyptians as the symbol of life.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cryptesthesia:")]), _vm._v(" This expression, literally meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("hidden sensitivity,")]), _vm._v(" was coined by Professor Richert to serve as a collective term for clairvoyance, clairaudience, psychometry, telepathy, dowsing, premonitions, and in general for perception, of the mechanism of which science is ignorant. The cryptesthesia theory denies and intends to disprove the spiritistic explanations of these phenomena. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("extrasensory perception.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cryptomnesia:")]), _vm._v(" The spontaneous remembering of events or facts of knowledge without being able to recall how or when the event was witnessed or the knowledge acquired.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Crystal-gazing:")]), _vm._v(" An ancient method of divination, which induces a state of clairvoyance by gazing into a small crystal globe, in which a picture or series of pictures is seen.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Crystallomancy:")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Scrying")]), _vm._v(" (q.v.) using a mirror for the shiny surface gazed at.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cult:")]), _vm._v(" A body of rites and practices associated with the worship or propitiation of a particular divinity or group of supernatural beings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Culture hero:")]), _vm._v(" A historical person whose teachings, doings or accomplishments live on, usually in an idealized version, in the myths, legends and traditions of his tribe, race or people. Culture heroes are usually raised by posterity to a divine or semi-divine status or regarded to have been incarnations of high-ranking gods.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Curse:")]), _vm._v(" Any act or word designed to produce harm or injury by supernatural powers; an invocation of supernatural powers to wreak harm or injury upon a person, place or object. A qualified person can destroy the effect of a curse, by a blessing or a counter-curse.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cusp:")]), _vm._v(" ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("a")]), _vm._v(") An astrological term, used to designate the imaginary line which separates a Sign from adjoining Signs, a House from its adjoining Houses; ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("b")]), _vm._v(") an indeterminate but small arc contiguous to the boundary-line between adjacent Signs and Houses, wherein there is uncertainty as to the planet’s location at a particular moment, and ambiguity as to the planet’s influence in a borderline relationship.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cybele-Attis mysteries:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Phrygian mysteries.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cycle:")]), _vm._v(" A period of cosmic history, marking the beginning or end of some important event. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("manvantara.")]), _vm._v(") In "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astrology,")]), _vm._v(" the term is applied primarily to the recurrence of planetary conjunctions.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cyclops:")]), _vm._v(" In ancient Greek-Roman lore, a giant with a single eye, in the middle of his forehead. (Plural: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cyclopes.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Czarnobog:")]), _vm._v(" Literally "), _c('em', {
    staticClass: "i"
  }, [_vm._v("black god.")]), _vm._v(" In Slavonic mythology, the evil deity, the power of evil fighting the good deity ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Bielbog")]), _vm._v(").")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef23d63a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/e9780806537009_c03.vue
// module id = 81
// module chunks = 0